// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import SocialShareController from "./social_share_controller"
application.register("social-share", SocialShareController)

import NativeShareController from "./native_share_controller"
application.register("native-share", NativeShareController)

import TrixLinksController from "./trix_links_controller"
application.register("trix-links", TrixLinksController)

import TurboDialogController from "./turbo_dialog_controller"
application.register("turbo-dialog", TurboDialogController)

import Users__AddUserInterestsController from "./users/add_user_interests_controller"
application.register("users--add-user-interests", Users__AddUserInterestsController)

import Users__PasswordController from "./users/password_controller"
application.register("users--password", Users__PasswordController)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import Dropdown from "@stimulus-components/dropdown"
application.register("dropdown", Dropdown)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import SaveOfflineNewsController from "./save_offline_news_controller"
application.register("save-offline-news", SaveOfflineNewsController)

import PushToggleController from "./push_toggle_controller"
application.register("push-toggle", PushToggleController)

import FontSizeController from "./font_size_controller"
application.register("font-size", FontSizeController)
